module.exports = __webpack_public_path__ + "static/media/Согласие_на_обработку_персональных.358fd495.pdf";